import API_BASE, { getAuthHeaders } from "./api";

export class OrderService {
    // Get user's orders
    static async getMyOrders() {
        const response = await fetch(`${API_BASE}/orders/my-orders`, {
            method: 'GET',
            headers: getAuthHeaders(),
            credentials: 'include'
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || 'Failed to get orders');
        }

        return data.data;
    }

    // Get order by ID
    static async getOrderById(orderId) {
        const response = await fetch(`${API_BASE}/orders/${orderId}`, {
            method: 'GET',
            headers: getAuthHeaders(),
            credentials: 'include'
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || 'Failed to get order');
        }

        return data.data;
    }

    // Cancel order
    static async cancelOrder(orderId, reason) {
        const response = await fetch(`${API_BASE}/orders/cancel/${orderId}`, {
            method: 'PATCH',
            headers: getAuthHeaders(),
            body: JSON.stringify({ reason }),
            credentials: 'include'
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || 'Failed to cancel order');
        }

        return data.data;
    }

    // Track order (authenticated)
    static async trackOrder(orderId) {
        const response = await fetch(`${API_BASE}/orders/track/${orderId}`, {
            method: 'GET',
            headers: getAuthHeaders(),
            credentials: 'include'
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || 'Failed to track order');
        }

        return data.data;
    }

    // Track order by order number (public - no auth required)
    static async trackOrderByNumber(orderNumber, email = '', phone = '') {
        let url = `${API_BASE}/orders/track/${orderNumber}`;

        // Add verification parameters if provided
        const params = new URLSearchParams();
        if (email) params.append('email', email);
        if (phone) params.append('phone', phone);

        if (params.toString()) {
            url += `?${params.toString()}`;
        }

        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || 'Failed to track order');
        }

        return data.data;
    }

    // Get order invoice
    static async getOrderInvoice(orderId) {
        const response = await fetch(`${API_BASE}/orders/invoice/${orderId}`, {
            method: 'GET',
            headers: getAuthHeaders(),
            credentials: 'include'
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || 'Failed to get invoice');
        }

        return data.data;
    }

    // Download invoice PDF
    static async downloadInvoice(orderId) {
        const response = await fetch(`${API_BASE}/orders/invoice/${orderId}/download`, {
            method: 'GET',
            headers: getAuthHeaders(),
            credentials: 'include'
        });

        if (!response.ok) {
            throw new Error('Failed to download invoice');
        }

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `invoice-${orderId}.pdf`;
        link.click();
        window.URL.revokeObjectURL(url);
    }

    // Get order statuses
    static async getOrderStatuses() {
        const response = await fetch(`${API_BASE}/orders/statuses`, {
            method: 'GET',
            headers: getAuthHeaders(),
            credentials: 'include'
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || 'Failed to get order statuses');
        }

        return data.data;
    }
}